module.exports = __webpack_public_path__ + "6b78c7ec468eb0e13c6c5c4c39203986.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-ExtraBold.ttf
// module id = 1252
// module chunks = 0